import { setIsFiltersPanelExpanded } from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/action-creators";
import { trackError } from "app/pages/sales-intelligence/utils/errors/tracking";
import { errorCategoryMap, SiError } from "app/pages/sales-intelligence/utils/errors/types";
import { SwRedux } from "app/services/SwRedux";

export const onEnterListPage = () => {
    try {
        SwRedux.getInstance().dispatch(setIsFiltersPanelExpanded(false));
    } catch (error) {
        trackError(
            new SiError(
                "Failed to execute router hook",
                {
                    category: errorCategoryMap.service,
                    operation: "onEnterListPage",
                },
                { cause: error },
            ),
        );
    }
};
